import React from 'react';
import { Button, Grid, TextareaAutosize, Typography, withStyles } from '@material-ui/core';
// import CloseIcon from '@material-ui/icons/Close';

import axiosInstance from '../constatns';
import swal from '@sweetalert/with-react';

import { EVENT_ID, WEB_API } from '../constatns';

const styles = (theme) => ({});

class RegMemo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      memo: this.props.memoData ? this.props.memoData : '',
      // id: '',
    };
    this.saveMemo = this.saveMemo.bind(this);
  }

  componentDidMount() {}

  handleChange(type, e) {
    this.setState({ [type]: e.target.value });
  }

  saveMemo(id) {
    console.log(id);
    console.log(this.state.memo);
    if (this.state.memo.length === 0) {
      swal('', '메모 내용이 없습니다.', 'warning');
      return;
    }
    const updateStatus = {
      eventId: EVENT_ID,
      userId: id,
      // memo: this.state.memo,
    };
    updateStatus['memo'] = this.state.memo;
    axiosInstance.put(`${WEB_API}/user/mod`, updateStatus).then((_result) => {
      console.log(_result);
      if (_result.status === 200) {
        swal('Admin Memo', '수정되었습니다.', 'success');
        this.props.handleClose();
        window.location.reload();
      }
    });
  }
  render() {
    return (
      //   <Dialog open={this.props.openMemo} close={this.props.handleCloseMemo} maxWidth={'sm'} fullWidth>
      <Grid container item xs={12} style={{ padding: 20 }}>
        <Grid>
          <Typography gutterBottom style={{ width: 'auto', fontSize: 'x-large', color: '#237a9d' }}>
            Admin Memo 편집
          </Typography>
        </Grid>
        <TextareaAutosize
          style={{ width: '100%', padding: 20 }}
          minRows={10}
          value={this.state.memo}
          onChange={(e) => this.setState({ memo: e.target.value })}
        />
        <Grid container justifyContent="space-between" style={{ padding: 20 }}>
          <Button color="primary" variant="outlined" size={'large'} style={{ width: '45%' }} onClick={() => this.props.handleClose()}>
            취소
          </Button>
          <Button
            color="primary"
            variant="contained"
            size={'large'}
            style={{ width: '45%' }}
            onClick={() => this.saveMemo(this.props.userId)}
          >
            수정
          </Button>
        </Grid>
      </Grid>
      //   </Dialog>
    );
  }
}

export default withStyles(styles, { withTheme: true })(RegMemo);
